import { store } from "@store/storeConfig/store";
// ** Initial State
const initialState = {
  allTenants: [],
  allReminders: [],
  allmaintenances: [],
  total: 1,
  params: {},
  customTotal: null,
  token: JSON.parse(localStorage.getItem("accessToken")),
  getError: false,
  errorMsg: "Error occured!!",
  otpSuccess: false,
  setNewPassword: false,
  found_results: "",
  entries_per_page: "",
  total_results: "",
  fetching: false,
  updatePagination: 0,
  isTokenExpire: false,
};
// console.log(store)

// console.log('sssssssssssss', selectedUser)

const tenants = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_TENANTS":
      return {
        ...state,
        allTenants: action.data,
        customTotal: action.total,
        entries_per_page: action.entries_per_page,
        found_results: action?.found_results,
        total_results: action?.total_results,
      };
    case 'GET_ALL_REMINDERS': 
    return {
      ...state,
      allReminders: action.data,
      customTotal: action.total,
      entries_per_page: action.entries_per_page,
      found_results: action?.found_results,
      total_results: action?.total_results,
    };
    case "GET_ALL_PROPERTY_MAINTENANCE":
      return {
        ...state,
        allmaintenances: action.data,
        customTotal: action.total,
        entries_per_page: action.entries_per_page,
        found_results: action?.found_results,
        total_results: action?.total_results,
      }

    case "DELETE_TENANT":
      // console.log(action.data)
      return { ...state, allTenants: action.data };
    case 'DELETE_REMINDER':
      return {...state, allReminders: action.data}
    case "DELETE_TENANT_MAINTENANCE":
      return {...state, allmaintenances: action.data, total_results: state?.total_results - 1, found_results: state?.found_results - 1}
    case "GET_ERROR":
      return { ...state, getError: true, errorMsg: action.error };
    case "REMOVE_ERROR":
      return { ...state, getError: false, errorMsg: "" };
    default:
      return { ...state };
  }
};
export default tenants;
